import RmnSiderailBanner from 'components/Rmn/RmnSiderailBanner/RmnSiderailBanner';
import { withRmnSiderailBannerProps } from 'viewModel/rmn/rmnSiderailBanner/withRmnSiderailBannerProps';

const ConnectedRmnSiderailBanner = withRmnSiderailBannerProps(RmnSiderailBanner);

export default ConnectedRmnSiderailBanner;
